import { Stack, Theme } from '@mui/material';

import { ForgotPasswordForm } from '../../../components/forms/ForgotPasswordForm/ForgotPasswordForm';
import { BackButton } from '../../../components/common/Button/BackButton/BackButton';

export const ResetPassword = () => {
  return (
    <Stack
      gap={2}
      textAlign="center"
      sx={(theme: Theme) => ({
        background: theme.palette.gray[300],
        boxShadow: `0px -32px 30px 15px ${theme.palette.gray[300]}`,
      })}
    >
      <Stack sx={{ position: 'absolute', top: '6%', left: '22px', zIndex: 1 }}>
        <BackButton skipReloadPage />
      </Stack>
      <ForgotPasswordForm />
    </Stack>
  );
};
